<template>
    <div>
        <div class="block" style="margin-top: 1rem; margin-right: 0.5rem;">
            <b-select v-model="integrationId">
                <option
                        v-for="integration in optionsForIntegration"
                        :key="integration.id"
                        :value="integration.id"
                >{{integration.name}}
                </option>
            </b-select>
        </div>
        <b-table
                :narrowed="true"
                :striped="true"
                detailed
                detail-key="id"
                default-sort="name"
                :data="data"
        >
            <template slot-scope="props">
                <b-table-column label="ID" width="40" numeric field="id">{{props.row.id}}</b-table-column>
                <b-table-column label="Name" field="name" sortable>
                    <router-link :to="{path: '/configure/devices/' + props.row.id}">
                        {{props.row.name}}
                    </router-link>
                </b-table-column>
                <b-table-column label="Connected via..." field="integration_name" sortable centered>
                    {{props.row.integration_name}}
                </b-table-column>
                <b-table-column label="States" field="states" numeric>{{props.row.numStates}}</b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
                <div>
                    <div>ID: {{props.row.id}}</div>
                    <div>Integration ID: {{props.row.integration_id}}</div>
                    <div>Internal ID: {{props.row.internal_id}}</div>
                    <div v-if="props.row.hftParent && props.row.hftParent.length > 0">Parent:
                        <router-link :to="{path: '/configure/devices/' + props.row.parent_id}">{{props.row.hftParent}}
                        </router-link>
                        [parent id: {{props.row.parent_id}}]
                    </div>
                    <div v-if="props.row.topics">
                        Topics: {{props.row.topics.length}}
                        <ul v-if="props.row.topics.length > 0">
                            <li v-for="topic in props.row.topics" :key="topic.id">
                                <router-link v-if="hasPermission(13)" :to="{path: '/configure/wizard/object/' + topic.id}">{{topic.topic}}</router-link>
                                <span v-else>{{topic.topic}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BSelect from "buefy/src/components/select/Select";

  export default {
    components: {
      BSelect,
      BTableColumn
    },
    name: "device-list",
    data() {
      return {
        integrationId: 0
      };
    },
    computed: {
      ...mapGetters('devices', ['devices', 'topicsByDeviceId', 'deviceTopics', 'devicesByIntegrationId']),
      ...mapGetters('integrations', ['integrations']),
      ...mapGetters('auth', ['hasPermission']),
      optionsForIntegration() {
        const ret = [
          {
            id: 0,
            name: '- any -'
          }
        ];

        this.integrations.forEach(item => {
          ret.push({
            id: item.id,
            name: item.name
          });
        });

        return ret;
      },
      data() {
        if (!this.devices) {
          return [];
        }

        const ref = this.integrationId > 0 ? this.devicesByIntegrationId(this.integrationId) : this.devices;
        return ref.map(item => {
          return {
            ...item,
            numStates: item['data'] && item['data']['states'] ? Object.keys(item['data']['states']).length : 0,
            topics: this.topicsByDeviceId(item['id'])
          };
        });
      }
    }
  }
</script>

<style scoped>

</style>